<template>
  <v-data-table
    :headers="headers"
    :items="data"
    hide-actions
    :loading="loading"
    :custom-sort="sortByNum"
    class="primary home-table"
  >
    <template v-slot:items="props">
      <tr
        :class="highlight(props.item.plant_id)"
        @click="$emit('row-clicked', props.item)"
        @mouseover="() => countExpiryDate(props.item.plant_id)"
        class="primaryText--text"
      >
        <td class="overflowtext">
          <v-tooltip top content-class="custom-tooltip">
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.item.plant_name }}</span>
            </template>
            <span>{{ props.item.plant_name }}</span>
          </v-tooltip>

          <div class="tooltip" v-show="toolTip(props.item.plant_id)">
            <p class="renew-msg">{{ daysToExpire }} days to Expire</p>
            <p class="renew-msg">Renew till : {{ hoveredPlantRenew }}</p>
          </div>
        </td>
        <td class="overflowtext">
          <v-tooltip top content-class="custom-tooltip">
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.item.location }}</span>
            </template>
            <span>{{ props.item.location }}</span>
          </v-tooltip>
        </td>
        <td
          :class="[
            'overflowtext',
            props.item.generation === 'No data' ? 'error--text' : 'number--text',
          ]"
        >
          <span v-if="!isPlantExpired(props.item.plant_id)">
            <v-tooltip top content-class="custom-tooltip">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <span v-show="props.item.generation !== 'No data'">
                    {{ props.item.generation | numberWithCommas }}
                  </span>
                  <span v-show="props.item.generation == 'No data'">
                    {{ $t('No data') }}
                  </span>
                </span>
              </template>
              <div>
                <span v-show="props.item.generation !== 'No data'">{{ props.item.generation | numberWithCommas }}</span>
                <span v-show="props.item.generation == 'No data'">{{ $t('No data') }}</span>
              </div>
            </v-tooltip>
          </span>
        </td>
        <td
          :class="[
            'overflowtext',
            props.item.power === 'No data' ? 'error--text' : 'number--text',
          ]"
        >
          <span v-if="!isPlantExpired(props.item.plant_id)">
            <v-tooltip top content-class="custom-tooltip">
              <template v-slot:activator="{ on }">
          <span v-on="on">{{ props.item.power !== 'No data' ? props.item.power : $t('No data') }}</span>
              </template>
              <span>{{ props.item.power !== 'No data' ? props.item.power : $t('No data') }}</span>
            </v-tooltip>
          </span>
        </td>
        <td
          :class="[
            'overflowtext',
            props.item.ratio ? 'number--text' : 'error--text',
          ]"
          id="ratio"
        >
          <span v-if="!isPlantExpired(props.item.plant_id)">
            <v-tooltip content-class="custom-tooltip" top>
              <template v-slot:activator="{ on }">
                <span v-on="on" v-if="props.item.ratio == null">{{ $t('No data') }}</span>
                <span v-on="on" v-else-if="props.item.ratio > 100">---</span>
                <span v-on="on" v-else>{{ props.item.ratio | round }}</span>
              </template>
              <span v-if="props.item.ratio == null ">{{ $t('No data') }}</span>
              <span v-else-if="props.item.ratio > 100">---</span>
              <span v-else>{{ props.item.ratio | round }}</span>
            </v-tooltip>
          </span>
        </td>
        <td class="number--text overflowtext">
          <v-tooltip top content-class="custom-tooltip">
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.item.ac_capacity }}</span>
            </template>
            <span>{{ props.item.ac_capacity }}</span>
          </v-tooltip>
        </td>
        <td>
          <span v-if="!isPlantExpired(props.item.plant_id)">
            <span v-for="(value, key) in props.item.alert" v-bind:key="key">
              <AlertIndicator
                :alertTag="alertShorthand(key)"
                :tip="key.toUpperCase()"
                :alert="value === 'alert'"
                @click="
                  $emit('alert-action', {
                    plantId: props.item.plant_id,
                    alert: key,
                  })
                "
              ></AlertIndicator>
            </span>
          </span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import { mixin } from "@/util/mixin/index";

import AlertIndicator from "@/components/home/DataTable/AlertIndicator";

export default {
  props: {
    headers: {
      type: Array,
      default: function () {
        return [];
      },
    },
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [mixin],
  components: {
    AlertIndicator,
  },
  data() {
    return {
      daysToExpire: null,
      hoveredPlantRenew: "",
    };
  },
  computed: {
    ...mapGetters([
      "isNearingRenew",
      "isRenewExceeded",
      "isPlantExpired",
      "getExpiryDateCount",
      "getRenewDate",
    ]),
  },
  methods: {
    alertShorthand(device) {
      return device.charAt(0).toUpperCase();
    },
    sortByNum(item, index, isDesc) {
      function numericCompare(a, b) {
        if (isDesc === true) {
          if (
            parseFloat(a[index].toString().replace(/,/gi, "")) <
            parseFloat(b[index].toString().replace(/,/gi, ""))
          ) {
            return -1;
          }
          if (
            parseFloat(a[index].toString().replace(/,/gi, "")) >
            parseFloat(b[index].toString().replace(/,/gi, ""))
          ) {
            return 1;
          }
        } else if (isDesc === false) {
          if (
            parseFloat(a[index].toString().replace(/,/gi, "")) >
            parseFloat(b[index].toString().replace(/,/gi, ""))
          ) {
            return -1;
          }
          if (
            parseFloat(a[index].toString().replace(/,/gi, "")) <
            parseFloat(b[index].toString().replace(/,/gi, ""))
          ) {
            return 1;
          }
        }
        return 0;
      }

      function stringCompare(a, b) {
        if (isDesc === true) {
          if (a[index] < b[index]) {
            return -1;
          }
          if (a[index] > b[index]) {
            return 1;
          }
        } else if (isDesc === false) {
          if (a[index] > b[index]) {
            return -1;
          }
          if (a[index] < b[index]) {
            return 1;
          }
        }
        return 0;
      }

      function prSort(a, b) {
        if (isDesc === true) {
          if (typeof a[index] === typeof b[index]) {
            return a[index] < b[index] ? -1 : 1;
          }
          return typeof a[index] > typeof b[index] ? -1 : 1;
        } else if (isDesc === false) {
          if (typeof a[index] === typeof b[index]) {
            return a[index] > b[index] ? -1 : 1;
          }
          return typeof a[index] < typeof b[index] ? -1 : 1;
        }
        return 0;
      }
      if (index === "generation") {
        return item.sort(numericCompare);
      } else if (index === "plant_name") {
        return item.sort(stringCompare);
      } else if (index === "location") {
        return item.sort(stringCompare);
      } else if (index === "ratio") {
        return item.sort(prSort);
      } else if (index === "ac_capacity") {
        return item.sort(numericCompare);
      } else if (index === "power") {
        return item.sort(numericCompare);
      } else {
        return item;
      }
    },
    countExpiryDate(plantId) {
      this.daysToExpire = this.getExpiryDateCount(plantId);
      this.hoveredPlantRenew = this.getRenewDate(plantId);
    },
    highlight(plantId) {
      const renew = this.isNearingRenew(plantId);
      const exceededRenew = this.isRenewExceeded(plantId);
      const expired = this.isPlantExpired(plantId);
      const className = renew || exceededRenew || expired ? "con-tooltip" : "";
      return `${className} top`;
    },
    toolTip(plantId) {
      return this.daysToExpire != null || this.isNearingRenew(plantId);
    },
  },
};
</script>

<style>
.home-table {
  padding: 0 15px;
  height: calc(100vh - 33.2vh);
  display: flex;
}

.home-table .v-table tbody td {
  height: 42px;
}

.custom-tooltip {
  background-color: var(--v-primary-base) !important;
  color: var(--v-extraGrey-base);
  border-radius: 4px;
  border: 1px solid rgba(83, 122, 228, 0.418);
  z-index: 10 !important;
}

.home-table th {
  position: sticky;
  z-index: 2;
  top: 0;
  color: var(--v-extraGrey-base);
  font-weight: 600 !important;
  font-size: 20px;
}

.home-table .v-table__overflow {
  overflow: auto;
}

.home-table td {
  padding-left: 10px !important;
  max-width: 200px;
}

.home-table td:last-child {
  padding: 0 !important;
}

.overflowtext {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 1086px) and (min-width: 960px) {
  .home-table td {
    max-width: 100px;
  }
}

@media (max-width: 1200px) and (min-width: 550px) {
  .home-table {
    height: calc(100vh - 350px);
  }
}

@media (max-width: 1240px) {
  .home-table td:last-child {
    width: 600px;
  }
}
</style>
